<template>
  <div class="community-post-composer">
    <rich-text-editor
      v-model="text"
      placeholder="Compartilhe algo com a comunidade..."
    />

    <div v-if="image" class="composer-image mt-2">
      <img :src="image" alt="" />
      <button type="button" class="btn-remove-image" @click="image = null">
        Remover imagem
      </button>
    </div>

    <post-producer-controls
      v-if="canModerate"
      :publish-at.sync="publishAt"
      :is-pinned.sync="isPinned"
      :moderator-profile-code.sync="moderatorProfileCode"
    />

    <div
      class="composer-actions d-flex align-items-center justify-content-between mt-2"
    >
      <input-image id="composer-image" v-model="image">
        <span class="btn-attach">
          <i class="icon-image" /> Adicionar imagem
        </span>
      </input-image>

      <button
        class="btn btn-primary px-4"
        :disabled="loading || !canSubmit"
        @click="submit"
      >
        <loading :show="loading" small>{{ submitLabel }}</loading>
      </button>
    </div>
  </div>
</template>

<script>
import InputImage from "@/components/InputImage.vue";
import RichTextEditor from "./RichTextEditor.vue";
import PostProducerControls from "./PostProducerControls.vue";

export default {
  name: "PostComposer",
  components: { InputImage, RichTextEditor, PostProducerControls },
  props: {
    communityId: {
      type: String,
      required: true
    },
    canModerate: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      text: "",
      image: null,
      publishAt: null,
      isPinned: false,
      moderatorProfileCode: null,
      loading: false
    };
  },
  computed: {
    canSubmit() {
      return !!(this.text && this.text.trim()) || !!this.image;
    },
    isScheduled() {
      return !!this.publishAt && new Date(this.publishAt) > new Date();
    },
    submitLabel() {
      return this.isScheduled ? "Agendar" : "Publicar";
    }
  },
  methods: {
    submit() {
      if (!this.canSubmit) return;
      this.loading = true;
      const action = this.canModerate
        ? "community/createProducerPost"
        : "community/createPost";
      const payload = {
        id: this.communityId,
        text: this.text,
        image: this.image
      };
      if (this.canModerate) {
        payload.publish_at = this.publishAt;
        payload.is_pinned = this.isPinned;
        payload.moderator_profile_code = this.moderatorProfileCode;
      }
      this.$store
        .dispatch(action, payload)
        .then(post => {
          this.$message.success(
            this.isScheduled ? "Publicação agendada" : "Publicação criada"
          );
          this.reset();
          this.$emit("created", post);
        })
        .catch(error => {
          const message =
            error?.response?.data?.non_field_errors?.[0] ||
            error?.response?.data?.moderator_profile_code?.[0] ||
            error?.response?.data?.publish_at?.[0] ||
            "Não foi possível publicar";
          this.$message.error(message);
        })
        .finally(() => {
          this.loading = false;
        });
    },
    reset() {
      this.text = "";
      this.image = null;
      this.publishAt = null;
      this.isPinned = false;
      this.moderatorProfileCode = null;
    }
  }
};
</script>

<style lang="scss" scoped>
.community-post-composer {
  padding: 16px;
  border-radius: 12px;
  border: 1px solid rgba(128, 128, 128, 0.2);

  .composer-image {
    position: relative;
    display: inline-block;

    img {
      max-width: 100%;
      max-height: 240px;
      border-radius: 8px;
    }

    .btn-remove-image {
      display: block;
      margin-top: 4px;
      border: none;
      background: transparent;
      color: #ff757e;
      font-size: 12px;
      padding: 0;
    }
  }

  .btn-attach {
    display: inline-flex;
    align-items: center;
    font-size: 14px;

    i {
      font-size: 18px;
      margin-right: 6px;
    }
  }
}
</style>
